<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap v-if="initStatus === 1">
      <v-flex xs12>
        <v-stepper :value="quoteLifeCycle" class="quoteLifeCycle">
          <v-stepper-header>
            <v-stepper-step step="1" :complete="quoteLifeCycle > 1">General</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="2" :complete="quoteLifeCycle > 2">Plans</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="3" :complete="quoteLifeCycle > 3">Applicant</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="4" :complete="quoteLifeCycle > 4">Insured</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="5" :complete="quoteLifeCycle > 5">Premium Summary</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="6" :complete="quoteLifeCycle > 6">Payment</v-stepper-step>
          </v-stepper-header>
        </v-stepper>
      </v-flex>
      <v-flex :lg8="!minimized" :lg12="minimized" xs12 :order-lg1="!minimized" :order-lg2="minimized" order-xs2>
        <transition name="slide-x-transition" mode="out-in">
          <router-view></router-view>
        </transition>
        <!-- The following dialog will work with leaveQuote Mixin (individual module to follow this structure:: just change the title) -->
        <promptLeave title="PA" v-model="promptLeave" @exit="doExit" @saveAndExit="doSaveAndExit"></promptLeave>
      </v-flex>
      <v-flex :lg4="!minimized" :lg12="minimized" xs12 :order-lg2="!minimized" :order-lg1="minimized" order-xs1>
        <p-a-quick-info v-model="minimized"></p-a-quick-info>
      </v-flex>
    </v-layout>
    <loader v-else :card="false" :height="425" :init="doInit" loadText="Loading PA Quotation Details..." errorText="Failed to load PA Quotation Details" :loading="initStatus === 0"></loader>
  </v-container>
</template>

<script>
import PromptLeave from '../../shared/leaveQuote/PromptLeave'
import { leaveQuote } from '../../shared/leaveQuote'
import PAQuickInfo from './PAQuickInfo'

export default {
  data() {
    return {
      // An incomplete experiment on UI
      minimized: false
    }
  },
  computed: {
    initStatus() {
      return this.$store.state.agency.quotation.init
    },
    quoteLifeCycle() {
      return this.$store.state.agency.quotation.quoteLifeCycle
    }
  },
  methods: {
    doInit() {
      this.$store.dispatch('paQuoteInit')
    }
  },
  mounted() {
    if (this.initStatus !== 1) {
      this.doInit()
    }
  },
  components: {
    PromptLeave,
    PAQuickInfo
  },
  mixins: [
    leaveQuote
  ]
}
</script>

<style lang="scss">
</style>
